import { render, staticRenderFns } from "./Backdrop.vue?vue&type=template&id=008d4c46&"
import script from "./Backdrop.vue?vue&type=script&lang=js&"
export * from "./Backdrop.vue?vue&type=script&lang=js&"
import style0 from "./Backdrop.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports